import styled from 'styled-components';
import { ReactComponent as BankPix } from '../../assets/icons/bank_pix.svg';
import { ReactComponent as CleanName } from '../../assets/icons/clean_name.svg';
import { ReactComponent as FastNegotiation } from '../../assets/icons/fast_negotiation.svg';
import { ReactComponent as Security } from '../../assets/icons/security.svg';
import { ReactComponent as MeirelesPix } from '../../assets/icons/pix_meireles.svg';
import { ReactComponent as CreditCard } from '../../assets/icons/credit-card.svg';
import { ReactComponent as BarCode } from '../../assets/icons/barcode_meireles.svg';

const LIGHT_BLUE = '#45C1EF';
const PETROLEO_BLUE = '#003854';
const WHITE = '#FFFFFF';
const TEXT_DARK = '#003854';
const LIGHT_GRAY = '#D9D9D9';

const centeredFlex = `
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PageContainer = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', Roboto, Helvetica,
    Arial, sans-serif;
  background-color: ${WHITE};
`;

export const SectionTitle = styled.h2<{ dark?: boolean }>`
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 56px;
  color: ${({ dark }) => (dark ? WHITE : LIGHT_BLUE)};

  @media (max-width: 768px) {
    font-size: 25px;
    margin-bottom: 32px;
  }
`;

export const HeaderSection = styled.header<{ bgImage?: string }>`
  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left center right;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding-right: 240px;

  @media (max-width: 768px) {
    padding-right: 0px;
    background-position: calc(100% + 100px);
    align-items: center;
    max-height: 500px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormLogo = styled.img`
  max-width: 400px;
  margin-right: 35px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    max-width: 270px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
`;

export const LoginCard = styled.div`
  width: 465px;
  box-shadow: 10px 10px 22.6992px -6px #0000005e;
  border-radius: 35px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 320px;
    border-radius: 20px;
  }
`;

export const FormBox = styled.div`
  background-color: ${PETROLEO_BLUE};
  color: ${WHITE};
  padding: 48px 32px 32px 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const FormTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 24px;
  width: 280px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const FormInstruction = styled.p`
  font-size: 12px;
`;

export const FormInput = styled.input`
  width: 100%;
  height: 50px;
  padding: 10px;
  border-radius: 15px;
  font-size: 25px;
  text-align: center;
  background: ${LIGHT_GRAY};
  color: ${TEXT_DARK};
  margin: 20px 0 15px 0;

  @media (max-width: 768px) {
    height: 45px;
  }

  &::placeholder {
    color: ${PETROLEO_BLUE};
    font-size: 25px;
    font-weight: 700;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const ButtonArea = styled.div`
  background-color: ${LIGHT_GRAY};
  display: flex;
  align-items: center;
  text-align: center;
  height: 60px;
  cursor: pointer;
  transition: ease 0.2s all;

  &:hover {
    background-color: #ccc;
  }

  @media (max-width: 768px) {
    height: 50px;
  }
`;

export const FormButton = styled.button`
  background: none;
  border: none;
  color: ${TEXT_DARK};
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  width: 100%;
`;

export const BenefitsSection = styled.section`
  background-color: ${WHITE};
  padding: 80px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 40px 12px;
  }
`;

export const BenefitsGrid = styled.div`
  display: flex;
  gap: 34px;
  align-items: center;
  height: 261px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 25px;
    height: auto;
  }
`;

export const BenefitCard = styled.div`
  background-color: ${LIGHT_BLUE};
  border-radius: 35px;
  text-align: center;
  max-width: 261px;
  height: 100%;
  padding: 30px;

  @media (max-width: 768px) {
    height: 190px;
    max-width: 190px;
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const BenefitIcon = styled.div`
  color: ${WHITE};
  font-size: 40px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    margin-bottom: 0px;
  }
`;

export const BankPixIcon = styled(BankPix)`
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;
export const CleanNameIcon = styled(CleanName)`
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;
export const FastNegotiationIcon = styled(FastNegotiation)`
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;
export const SecurityIcon = styled(Security)`
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const BenefitTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${WHITE};
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const BenefitDescription = styled.p`
  font-size: 14px;
  color: ${WHITE};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const StepsSection = styled.section`
  background-color: ${PETROLEO_BLUE};
  padding: 110px 0px;
  color: ${WHITE};

  @media (max-width: 768px) {
    padding: 40px 12px;
  }
`;

export const StepsContainer = styled.div`
  ${centeredFlex}
  gap: 16px;
  max-width: 1180px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    max-width: 100%;
  }
`;

export const Step = styled.div`
  ${centeredFlex}
  flex-direction: column;
  text-align: center;
  flex: 1;
`;

export const StepCircle = styled.div`
  width: 212px;
  height: 212px;
  border-radius: 50%;
  background-color: ${LIGHT_BLUE};
  color: ${PETROLEO_BLUE};
  font-size: 150px;
  font-weight: 700;
  margin-bottom: 24px;
  ${centeredFlex}

  @media (max-width: 768px) {
    width: 130px;
    height: 130px;
    font-size: 80px;
  }
`;

export const StepContent = styled.div`
  min-height: 80px;
`;

export const StepTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const StepDescription = styled.p`
  font-size: 16px;
  opacity: 0.9;
  padding: 0 8px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const PartnerSection = styled.section<{ bgImage?: string }>`
  padding: 96px 24px;
  position: relative;

  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : 'none')};
  background-repeat: no-repeat;
  background-position: calc(100% + 50px) center;
  background-size: contain;

  @media (max-width: 768px) {
    padding: 40px 12px 0px 12px;
  }
`;

export const PartnerContent = styled.div`
  display: flex;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 100%;
  }
`;

export const PartnerInfo = styled.div`
  flex-basis: 50%;

  h2 {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 24px;
    color: ${LIGHT_BLUE};

    @media (max-width: 768px) {
      font-size: 25px;
    }
  }

  div {
    margin-bottom: 32px;
  }

  p {
    font-size: 17px;
    margin-bottom: 25px;
    max-width: 465px;
    color: ${PETROLEO_BLUE};

    @media (max-width: 768px) {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    text-align: center;
    padding: 0px 30px;
  }
`;

export const PartnerLogo = styled.img`
  @media (max-width: 768px) {
    max-width: 180px;
    margin-bottom: 40px;
  }
`;

export const PartnerImage = styled.img`
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const FaqSection = styled.section`
  background-color: ${PETROLEO_BLUE};
  padding: 80px 24px;
  color: ${WHITE};

  @media (max-width: 768px) {
    padding: 40px 12px 20px 12px;
  }
`;

export const AccordionItem = styled.div`
  max-width: 930px;
  margin: 0 auto 1rem auto;
  border: 1px solid ${LIGHT_BLUE};
  border-radius: 35px;
  margin-bottom: 35px;
  transition: all 0.4s ease-in-out;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 20px;
    border-radius: 25px;
  }
`;

export const AccordionHeader = styled.div`
  padding: 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  font-weight: 500;

  p {
    max-width: 700px;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  @media (max-width: 768px) {
    font-size: 16px;
    gap: 15px;
  }
`;

export const ChevronWrapper = styled.div`
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background-color: ${LIGHT_BLUE};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 29px;
    height: 29px;
  }
`;

export const AccordionContent = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? '200px' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  overflow: hidden;
  transition: all 0.4s ease-in-out;
  padding: 0 24px;

  p {
    font-size: 16px;
    opacity: 0.9;
    padding: 0 8px 24px 0;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background-color: ${LIGHT_BLUE};
    margin-bottom: 24px;
  }
`;

export const Footer = styled.footer`
  background-color: ${LIGHT_BLUE};
  color: ${WHITE};
  padding: 48px 24px;

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const FooterContent = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 32px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const FooterColumn = styled.div`
  h4 {
    margin-bottom: 12px;
    font-size: 30px;
    font-weight: 700;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }

  p {
    font-size: 17px;
    font-weight: 500;
    max-width: 260px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

export const PaymentIcons = styled.div`
  display: flex;
  gap: 36px;
  font-size: 40px;

  @media (max-width: 768px) {
    gap: 30px;
  }
`;

export const PaymentIconsWrapper = styled.div`
  display: flex;
  background-color: ${WHITE};
  width: 96px;
  height: 70px;
  justify-content: center;
  align-items: center;
  border-radius: 15px;

  @media (max-width: 768px) {
    width: 70px;
    height: 40px;
    border-radius: 10px;
  }
`;

export const MeirelesPixIcon = styled(MeirelesPix)`
  @media (max-width: 768px) {
    width: 50px;
    height: 39px;
  }
`;

export const CreditCardIcon = styled(CreditCard)`
  color: ${PETROLEO_BLUE};
  width: 60px;
  height: 49px;

  @media (max-width: 768px) {
    width: 50px;
    height: 39px;
  }
`;

export const BarCodeIcon = styled(BarCode)`
  @media (max-width: 768px) {
    width: 40px;
    height: 29px;
  }
`;
